// extracted by mini-css-extract-plugin
module.exports = {"gallery_sec":"Activitygallery_gallery_sec__kT0F8","gallery_main":"Activitygallery_gallery_main__5W0te","gallery_child":"Activitygallery_gallery_child__JH5rB"};